import React, { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db, auth } from './firebase';
import EstablishmentCard from './EstablishmentCard';
import { Modal, Button, ListGroup, Badge } from 'react-bootstrap';
import Login from './Login';
import { signOut } from "firebase/auth";
import './responsive_style.css';

function PCStatus() {
  const [user, setUser] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [selectedEstablishment, setSelectedEstablishment] = useState(null);

  // Modale contact
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactToShow, setContactToShow] = useState(null);
  const [siteName, setSiteName] = useState('');

  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged(currentUser => {
      setUser(currentUser);
    });
    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    if (!user) {
      setStatusData([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const collectionRef = collection(db, "MonitoringStatus");

    const unsubscribe = onSnapshot(collectionRef, (querySnapshot) => {
      if (querySnapshot.empty) {
        console.log("Aucun document dans la collection MonitoringStatus");
      }
      const data = querySnapshot.docs.map(doc => {
        const docData = doc.data();

        const ipObj = docData.IPs || {};
        const ip_list = Object.keys(ipObj).map(ip => ({
          ip,
          name: ipObj[ip].description || '',
          status: ipObj[ip].reachable ? 'success' : 'failure'
        })).sort((a, b) => a.ip.localeCompare(b.ip));

        const services = docData.Services || {};
        const elisathStatus = services.Elisath === true ? 'success' : 'failure';
        const mariaDBStatus = services.MariaDB === true ? 'success' : 'failure';

        return {
          id: doc.id,
          service_tag: docData.ServiceTag || 'N/A',
          ip_list,
          timestamp: docData.Timestamp || null,
          elisathStatus,
          mariaDBStatus,
          contact: docData.Contact || null,
        };
      });
      setStatusData(data);
      setLoading(false);
    }, (error) => {
      console.error("Erreur Firestore lors de la récupération:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  if (!user) {
    return <Login onLogin={() => {}} />;
  }

  if (loading) {
    return <div>Chargement...</div>;
  }

  const handleCardClick = (establishment) => {
    setSelectedEstablishment(establishment);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEstablishment(null);
  };

  // Ouvrir modale contact
  const handleInfoClick = (siteTag, contact) => {
    setSiteName(siteTag.replace(/_/g, ' '));
    setContactToShow(contact);
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setContactToShow(null);
    setSiteName('');
  };

  return (
    <div style={{ padding: "20px", position: 'relative' }}>
      <h2>Liste des établissements</h2>
      <div className="grid-container">
        {statusData.length > 0 ? (
          statusData.map(estab => (
            <EstablishmentCard
              key={estab.id}
              serviceTag={estab.service_tag}
              timestamp={estab.timestamp}
              elisathStatus={estab.elisathStatus}
              mariaDBStatus={estab.mariaDBStatus}
              onClick={() => handleCardClick(estab)}
              onInfoClick={() => handleInfoClick(estab.service_tag, estab.contact)}
            />
          ))
        ) : (
          <div>Aucun établissement disponible</div>
        )}
      </div>

      {/* Modal liste IP */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedEstablishment && selectedEstablishment.service_tag.replace(/_/g, ' ')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEstablishment && selectedEstablishment.ip_list.length > 0 ? (
            <ListGroup>
              {selectedEstablishment.ip_list.map(({ ip, name, status }, idx) => (
                <ListGroup.Item key={idx} className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{ip}</strong> - <span style={{ fontSize: '80%' }}>{name}</span>
                  </div>
                  <Badge bg={status === 'success' ? 'success' : 'danger'}>
                    {status === 'success' ? '✓' : '✗'}
                  </Badge>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <p>Aucune adresse IP disponible</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>Fermer</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal info contact */}
      <Modal show={showContactModal} onHide={handleCloseContactModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{siteName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {contactToShow ? (
            <>
              <p><strong>Nom :</strong> {contactToShow.name || 'N/A'}</p>
              <p>
                <strong>Téléphone :</strong>{' '}
                {contactToShow.phone ? (
                  <a href={`tel:${contactToShow.phone}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {contactToShow.phone}
                  </a>
                ) : (
                  'N/A'
                )}
              </p>
              <p>
                <strong>Email :</strong>{' '}
                {contactToShow.email ? (
                  <a href={`mailto:${contactToShow.email}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    {contactToShow.email}
                  </a>
                ) : (
                  'N/A'
                )}
              </p>
            </>
          ) : (
            <p>Aucune information de contact disponible.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseContactModal}>Fermer</Button>
        </Modal.Footer>
      </Modal>

      {/* Bouton Exit déconnexion flottant en bas droite */}
      <button
        onClick={() => signOut(auth)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          cursor: 'pointer',
          fontSize: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
          zIndex: 1050,
        }}
        aria-label="Exit (Déconnexion)"
        title="Se déconnecter"
      >
        ➜
      </button>
    </div>
  );
}

export default PCStatus;
